import { render, staticRenderFns } from "./GnbArea.vue?vue&type=template&id=6659840e&"
import script from "./GnbArea.vue?vue&type=script&lang=js&"
export * from "./GnbArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports